var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "m21.688 8.04-3.18-3.18c-1.2-1.2-2.85-1.14-3.66.15l-1.77 2.8 5.67 5.67 2.8-1.77c1.21-.77 1.28-2.54.14-3.67Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  d: "m18.749 13.47.24 4.12c.23 2.3-.57 3.1-2.75 3.36l-8.72 1.03c-1.84.21-3.16-1.11-2.94-2.94l.98-8.28m7.52-2.95-1.75-.11m-5.55 13.08 3.18-3.19"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#21241E",
  strokeMiterlimit: 10,
  d: "M11.5 6.5c0 .41-.06.82-.17 1.2a4.45 4.45 0 0 1-1.37 2.18C9.17 10.58 8.14 11 7 11q-.765 0-1.44-.24a4.47 4.47 0 0 1-2.41-1.94A4.5 4.5 0 0 1 2.5 6.5c0-1.42.65-2.69 1.69-3.51A4.494 4.494 0 0 1 11.5 6.5ZM7.017 8.18V4.82m1.64 1.68h-3.36"
})));
export { SvgVector as ReactComponent };
export default __webpack_public_path__ + "3b020ccc9015f3f157460847a93e1283.svg";